import React from 'react';
import ChatBox from './ChatBox';
import './Home.css';

function Home({ signOut, user }) {
  return (
    <div className="Home">
      <header>
        <h1>Welcome, {user.attributes.email}!</h1>
        <button className="logout-btn" onClick={signOut}>
          <span>Logout</span>
        </button>
      </header>
      <main>
        <ChatBox />
      </main>
    </div>
  );
}

export default Home;